import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'kiene-change-antibiogramm-client-dialog',
    templateUrl: './change-antibiogramm-client-dialog.component.html',
    styleUrls: ['./change-antibiogramm-client-dialog.component.scss'],
})
export class ChangeAntibiogrammClientDialogComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
